export default __webpack_public_path__ + "static/media/wilfred-bruise.14a3d566.jpg";